import $ from 'jquery';
import React from 'react';
import Alert from 'react-bootstrap/lib/Alert';
import autoBind from '../../modules/autoBind';
import Spinner from '../../modules/Spinner.jsx';
import Users from './Users.jsx';
import XTNAChart from '../xtna/Chart.jsx';
import XTNAResults from '../xtna/Results.jsx';
import XTNAForm from '../xtna/Form.jsx';
import XTNATrabajoChart from '../xtnaTrabajo/Chart.jsx';
import Benzinger from '../benzinger/Benzinger';
import BenzingerChart from '../benzinger/Chart.jsx';
import BenzingerForm from '../benzinger/Form.jsx';
import BenzingerResults from '../benzinger/Results.jsx';
import Questionnaire1 from '../questionnaires/Questionnaire1.jsx';
import Questionnaire2 from '../questionnaires/Questionnaire2.jsx';
import XTNAReportGenerator from '../reports/XTNAReportGenerator.jsx';
import HumanFactorsReportGenerator from '../reports/HumanFactorsReportGenerator.jsx';
import { q1Questions, q2Questions } from '../questionnaires/QuestionnairesData';
var FileSaver = require('file-saver');

export default class UserDetails extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { benzinger: Benzinger.default(), benzingerStats: { i1: 0, i2: 0, e1: 0, e2: 0 } };
  }
  componentDidMount() {
    $.ajax({
      url: this.props.resourceUrl,
      method: 'GET'
    }).done((userResource) => this.setState({ userResource }))
    .fail(() => this.setState({ errorMessage: 'No se encontró el cliente.' }));
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  handleResize() {
    this.setState({ windowWidth: window.innerWidth });
  }

  unnacent(name){
    var new_name = name;
    new_name = new_name.replace(/á/g, 'a');
    new_name = new_name.replace(/é/g, 'e');
    new_name = new_name.replace(/í/g, 'i');
    new_name = new_name.replace(/ó/g, 'o');
    new_name = new_name.replace(/ú/g, 'u');
    new_name = new_name.replace(/ñ/g, 'n');
    new_name = new_name.replace(/Á/g, 'A');
    new_name = new_name.replace(/É/g, 'I');
    new_name = new_name.replace(/Í/g, 'E');
    new_name = new_name.replace(/Ó/g, 'O');
    new_name = new_name.replace(/Ú/g, 'U');
    new_name = new_name.replace(/Ñ/g, 'N');
    return new_name;
  }

  exportBenziger(){
    var name = this.unnacent(this.state.userResource.name);
    fetch(this.props.exportBenziger, {
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          userId: this.state.userResource.id,
          username: this.props.user.user,
          userType: this.props.user.userType
        }),
        responseType: 'blob'
      })
      .then(response => response.blob())
      .then(blob => {
        if(blob.size !== 0){
          FileSaver.saveAs(blob, 'Respuestas Benziger-'+name+'.xlsx');
        } else {
          alert('No ha completado el cuestionario.');
        }

      });
  }

  render() {
    if (this.state.errorMessage) {
      return <Alert bsStyle="danger" onDismiss={() => this.setState({ errorMessage: null })}>{this.state.errorMessage}</Alert>;
    }

    if (!this.state.userResource) {
      return <Spinner />;
    }

    if (this.state.viewingAnswers) {
      let data, idx = 0;
      if (this.state.viewingAnswers === 1) {
        data = [['', 'Pregunta', 'Respuesta'], ...q1Questions.map((q) => [idx+1, q.replace(/,/g, ';'), this.state.userResource.questionnaire.answers[0][idx++]])];
      } else {
        data = [['', 'Más', 'Menos'], ...q2Questions.map((q) => {
          const answer = this.state.userResource.questionnaire.answers[1][idx];
          const lessIndex = answer[0] - 1;
          const mostIndex = answer[1] - 1;
          return [idx+1, q2Questions[idx][lessIndex], q2Questions[idx++][mostIndex]];
        })];
      }
      let csvContent = "data:text/csv;charset=utf-8,";
      let dataString = '';
      data.forEach((infoArray, index) => {
         dataString = infoArray.join(",");
         csvContent += index < data.length ? dataString+ "\n" : dataString;
      });

      csvContent = csvContent.replace(/á/g, 'a');
      csvContent = csvContent.replace(/é/g, 'e');
      csvContent = csvContent.replace(/í/g, 'i');
      csvContent = csvContent.replace(/ó/g, 'o');
      csvContent = csvContent.replace(/ú/g, 'u');
      csvContent = csvContent.replace(/ñ/g, 'n');
      csvContent = csvContent.replace(/Á/g, 'A');
      csvContent = csvContent.replace(/É/g, 'I');
      csvContent = csvContent.replace(/Í/g, 'E');
      csvContent = csvContent.replace(/Ó/g, 'O');
      csvContent = csvContent.replace(/Ú/g, 'U');
      csvContent = csvContent.replace(/Ñ/g, 'N');

      const smallScreen = this.state.windowWidth < 1200;
      const questionnaire = this.state.viewingAnswers === 1 ?
        <Questionnaire1 smallScreen={smallScreen} value={this.state.userResource.questionnaire.answers[0]} editable={false} /> : 
        <Questionnaire2 value={this.state.userResource.questionnaire.answers[1]} editable={false} />
      return (
        <div>
          <ol className="breadcrumb">
            <li><a href="#/clientes">Clientes</a></li>
            <li><a onClick={() => this.setState({ viewingAnswers: null })}>{this.state.userResource.name}</a></li>
            <li className="active">Cuestionario {this.state.viewingAnswers}</li>
          </ol>
          <button className='btn btn-success' onClick={() => window.open(encodeURI(csvContent))}>Exportar</button>
          {questionnaire}
        </div>
      );
    }

    return (
      <div>
        <ol className="breadcrumb">
          <li><a href="#/clientes">Clientes</a></li>
          <li className="active">{this.state.userResource.name}</li>
        </ol>
        {this.renderRow(<b>Id: </b>, this.state.userResource.id)}
        {this.renderRow(<b>Nombre: </b>, this.state.userResource.name)}
        {this.renderRow(<b>Empresa: </b>, this.state.userResource.company)}
        {this.renderRow(<b>Edad: </b>, this.state.userResource.age)}
        {this.renderRow(<b>Sexo: </b>, this.state.userResource.sex === 'M' ? 'Masculino' : this.state.userResource.sex === 'F' ? 'Femenino' : '-')}
        {this.renderRow(<b>Fecha Creación: </b>, moment(this.state.userResource.creationdate).format('DD/MM/YYYY'))}
        {this.renderRow(<b>Fecha de Expiración: </b>, this.state.userResource.questionnaire.expirationDate ? moment(this.state.userResource.questionnaire.expirationDate).format('DD/MM/YYYY') : '-')}
        {this.renderRow(<b>Estatus Cuestionario: </b>, Users.getQuestionnaireStatus(this.state.userResource.questionnaire.stage))}
        {this.renderRow(<b>Fecha de Respuesta: </b>, this.state.userResource.questionnaire.completionDate ? moment(this.state.userResource.questionnaire.completionDate).format('DD/MM/YYYY') : '-')}
        {this.renderRow(<b>Email: </b>, this.state.userResource.email)}
        <If condition={this.state.userResource.questionnaire.stage > 2}>
          {this.renderRow(<b>Cuestionario 1:</b>, <button type='button' className='btn btn-default' onClick={() => this.setState({ viewingAnswers: 1 })}>Ver Respuestas</button>)}
        </If>
        <If condition={this.state.userResource.questionnaire.stage > 3}>
          {this.renderRow(<b>Cuestionario 2:</b>, <button type='button' className='btn btn-default' onClick={() => this.setState({ viewingAnswers: 2 })}>Ver Respuestas</button>)}
        </If>
        <If condition={this.props.userType === 'admin'}>
          {this.renderRow(<b>Cuestionario Benziger:</b>, <button type='button' className='btn btn-default' onClick={this.exportBenziger} >Ver Respuestas</button>)}
        </If>
        <If condition={this.state.userResource.questionnaire.stage === 4}>
          <div>
          {this.renderRow(<b>Reportes: </b>, null)}
          {this.renderRow(
            <XTNAReportGenerator
              licenseConsumed={() => 0}
              personalData={R.merge(this.state.userResource, { date: moment(this.state.userResource.questionnaire.completionDate) })}
              xtna={this.state.userResource.results.xtna}
              valid={true}
              chartsIds={{ xtna: `xtna-chart-${this.state.userResource.id}`, xtnaTrabajo: `xtna-trabajo-chart-${this.state.userResource.id}` }}
              reportTemplateUrl={this.state.userResource._rels.xtnaReportTemplate} />,
            <HumanFactorsReportGenerator licenseConsumed={() => 0} personalData={R.merge(this.state.userResource, { date: moment(this.state.userResource.questionnaire.completionDate) })} xtna={this.state.userResource.results.xtna} benzinger={this.state.benzinger} valid={true} chartsIds={{ xtna: `xtna-chart-${this.state.userResource.id}`, benzinger: `benzinger-chart-${this.state.userResource.id}`, xtnaTrabajo: `xtna-trabajo-chart-${this.state.userResource.id}` }} reportTemplateUrl={this.state.userResource._rels.humanFactorsReportTemplate} {...this.state.benzingerStats}/>
          )}
            <br />
            <center>
              {this.renderRow(<b>XTNA</b>, <b>Benzinger</b>)}
            </center>
            <br />
            {this.renderRow(this.renderResults('xtna'), this.renderResults('benzinger'))}
            <div className='col-xs-10 col-xs-offset-1'>
              <XTNATrabajoChart {...this.state.userResource.results.xtna} id={`xtna-trabajo-chart-${this.state.userResource.id}`}/>
            </div>
          </div>
        </If>
      </div>
    );
  }
  renderResults(type) {
    if (type === 'xtna') {
      return (
        <div>
          <center>
            <XTNAChart id={`xtna-chart-${this.state.userResource.id}`} {...this.state.userResource.results.xtna} />
            <XTNAForm editable={false} value={this.state.userResource.results.xtna} />          
          </center>
          <XTNAResults {...this.state.userResource.results.xtna} />
        </div>
      )
    } else if (type === 'benzinger') {
      return (
        <div>
          <center>
            <BenzingerChart id={`benzinger-chart-${this.state.userResource.id}`} {...this.state.benzinger} /> 
            <BenzingerForm value={this.state.benzinger} stats={this.state.benzingerStats} onStatChange={(stats) => this.setState({ benzingerStats: stats })} onChange={(benzinger) => this.setState({ benzinger })} /> 
          </center>
        </div>
      );
    }
  }
  renderRow(left, right) {
    return (
      <div className='row' style={{ margin: '5px' }}>
        <div className='col-xs-10 col-xs-offset-1 col-md-4 col-md-offset-1'>
          {left}
        </div>
        <div className='col-xs-10 col-xs-offset-1 col-md-4 col-md-offset-1'>
          {right}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/users/UserDetails.jsx